import { render, staticRenderFns } from "./quickAccessPanel.vue?vue&type=template&id=58754785&scoped=true"
import script from "./quickAccessPanel.vue?vue&type=script&lang=js"
export * from "./quickAccessPanel.vue?vue&type=script&lang=js"
import style0 from "./quickAccessPanel.vue?vue&type=style&index=0&id=58754785&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58754785",
  null
  
)

export default component.exports